/**
 * CUSTOM CORE JS - NutriHangar Theme
 * Gestione Menu, UI Interactions, Slider e Header Logic
 */

document.addEventListener('DOMContentLoaded', () => {
    
    // ==========================================================================
    // 1. GESTIONE MENU DESKTOP (CLICK PER APRIRE)
    // ==========================================================================
    const desktopItems = document.querySelectorAll('.shopigem-menu-item');
    
    desktopItems.forEach(item => {
        const link = item.querySelector('.shopigem-menu-link');
        if(link) {
            link.addEventListener('click', function(e) {
                // Se c'è un mega menu, previeni il link e apri il menu
                if (item.querySelector('.native-mega-dropdown')) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const wasActive = item.classList.contains('active');
                    
                    // Chiudi tutti gli altri
                    desktopItems.forEach(other => { 
                        if (other !== item) other.classList.remove('active'); 
                    });

                    // Toggle corrente
                    if (wasActive) { 
                        item.classList.remove('active'); 
                    } else { 
                        item.classList.add('active'); 
                    }
                }
            });
        }
    });

    // Chiudi menu cliccando fuori
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.shopigem-desktop-nav')) {
            desktopItems.forEach(item => item.classList.remove('active'));
        }
    });

    // ==========================================================================
    // 2. GESTIONE MENU MOBILE (DRAWER & ACCORDION)
    // ==========================================================================
    
    // Gestione Accordion (+ / -)
    const mobileToggles = document.querySelectorAll('.god-link.toggle-god');
    mobileToggles.forEach(btn => {
        // Clona per rimuovere vecchi listener
        const newBtn = btn.cloneNode(true);
        btn.parentNode.replaceChild(newBtn, btn);
        
        newBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const submenu = this.nextElementSibling;
            
            if (submenu.classList.contains('open')) {
                submenu.classList.remove('open');
                this.classList.remove('is-active-orange');
            } else {
                // Chiudi fratelli (opzionale, per ora lasciamo multipli aperti)
                submenu.classList.add('open');
                this.classList.add('is-active-orange');
            }
        });
    });

    // Apertura Drawer Mobile
    const oldBtn = document.querySelector('.mobile-menu-button');
    if (oldBtn) {
        const newBtn = oldBtn.cloneNode(true);
        oldBtn.parentNode.replaceChild(newBtn, oldBtn);
        
        newBtn.addEventListener('click', function(e) {
            e.preventDefault(); 
            e.stopPropagation();
            
            // Nascondi overlay standard se presente
            const ghostOverlay = document.querySelector('.site-overlay');
            if(ghostOverlay) ghostOverlay.style.display = 'none'; 
            
            const drawer = document.getElementById('shopigem-god-drawer');
            if(drawer) {
                drawer.classList.add('open');
                document.body.style.overflow = 'hidden';
            }
        });
    }

    // Chiusura Drawer
    const closeBtn = document.querySelector('.god-close');
    const drawer = document.getElementById('shopigem-god-drawer');
    
    const closeDrawer = () => {
        if(drawer) drawer.classList.remove('open');
        document.body.style.overflow = '';
    };

    if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
    
    // Chiudi drawer cliccando sullo sfondo scuro (pseudo-element click hack)
    if(drawer) {
        drawer.addEventListener('click', (e) => {
            if (e.target === drawer) closeDrawer();
        });
    }

    // ==========================================================================
    // 3. FADE OUT FOOTER (Header intelligente)
    // ==========================================================================
    const stickyHeader = document.querySelector('main-header');
    const monolith = document.getElementById('shopigem-monolith');
    const footer = document.querySelector('.ne-footer-wrapper') || document.querySelector('footer');

    // Disabilita sticky header nativo se confligge
    if (stickyHeader) stickyHeader.removeAttribute('data-sticky-header');

    if (footer) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const isPageShort = document.documentElement.scrollHeight <= (window.innerHeight + 150);
                
                if (isPageShort) {
                    if(monolith) monolith.classList.remove('header-fade-out');
                    if(stickyHeader) stickyHeader.classList.remove('header-fade-out');
                    return; 
                }

                // FIX: If Drawer is Open, DO NOT FADE OUT
                const godDrawer = document.getElementById('shopigem-god-drawer');
                if (godDrawer && godDrawer.classList.contains('open')) {
                     if(monolith) monolith.classList.remove('header-fade-out');
                     return;
                }

                if (entry.isIntersecting && window.scrollY > 100) {
                    if(monolith) monolith.classList.add('header-fade-out');
                    if(stickyHeader) stickyHeader.classList.add('header-fade-out');
                } else {
                    if(monolith) monolith.classList.remove('header-fade-out');
                    if(stickyHeader) stickyHeader.classList.remove('header-fade-out');
                }
            });
        }, { threshold: 0.05 }); // Attiva quando il 5% del footer è visibile
        
        observer.observe(footer);
    }

    // ==========================================================================
    // 4. GEMINI AUTO-SLIDER LOGIC (Ottimizzato con IntersectionObserver)
    // ==========================================================================
    const sliders = document.querySelectorAll('.gemini-slider-wrapper');
    
    if (sliders.length > 0) {
        const sliderObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const slider = entry.target;
                if (entry.isIntersecting) {
                    slider.play();
                } else {
                    slider.pause();
                }
            });
        }, { threshold: 0.1 });

        sliders.forEach(slider => {
            const track = slider.querySelector('.gps-track');
            const slides = slider.querySelectorAll('.gps-slide');
            if (slides.length < 2) return;

            let index = 0;
            const intervalTime = parseInt(slider.dataset.sliderInterval) || 5000;
            let slideInterval;

            // Metodo play aggiunto all'elemento DOM
            slider.play = () => {
                if (slideInterval) return; // Già in play
                slideInterval = setInterval(() => {
                    index++;
                    if (index >= slides.length) { index = 0; }
                    track.style.transform = `translateX(-${index * 100}%)`;
                }, intervalTime);
            };

            // Metodo pause
            slider.pause = () => {
                if (slideInterval) {
                    clearInterval(slideInterval);
                    slideInterval = null;
                }
            };

            // Mouse interaction
            slider.addEventListener('mouseenter', () => slider.pause());
            slider.addEventListener('mouseleave', () => slider.play());

            // Avvia osservatore
            sliderObserver.observe(slider);
        });
    }

    // ==========================================================================
    // 5. FIX VARIANTI INTELLIGENTE (CON QUICK VIEW SUPPORT & ANTI-CRASH)
    // ==========================================================================
    
    const manageVariantUI = (select) => {
        let validOptions = [];
        Array.from(select.options).forEach(opt => {
            if (!opt.disabled && !opt.hasAttribute('hidden') && opt.style.display !== 'none') {
                validOptions.push(opt.text);
            }
        });

        if (validOptions.length === 0 && select.selectedIndex >= 0) {
            validOptions.push(select.options[select.selectedIndex].text);
        }

        let textDiv = select.previousElementSibling;
        const isMyText = textDiv && textDiv.classList.contains('js-single-variant-text');

        if (validOptions.length <= 1) {
            const textToShow = validOptions[0] || select.value;
            if (isMyText) {
                textDiv.textContent = textToShow;
                textDiv.style.display = 'block';
            } else {
                const div = document.createElement('div');
                div.className = 'js-single-variant-text';
                div.textContent = textToShow;
                div.style.padding = '12px 0';
                div.style.fontSize = '15px';
                div.style.color = '#111';
                div.style.fontWeight = '500';
                div.style.lineHeight = '1.2';
                select.parentNode.insertBefore(div, select);
            }
            select.style.display = 'none';
        } else {
            if (isMyText) { textDiv.style.display = 'none'; }
            select.style.display = 'block';
        }
    };

    const observeSingleSelect = (select) => {
        if (select.dataset.hasObserver === 'true') return;
        
        const observer = new MutationObserver(() => { manageVariantUI(select); });
        observer.observe(select, { attributes: true, subtree: true, childList: true });
        
        select.dataset.hasObserver = 'true';
        manageVariantUI(select); 
    };

    // A. Esegui sulle select già presenti
    const existingSelects = document.querySelectorAll('select.product-variant-container');
    existingSelects.forEach(select => observeSingleSelect(select));

    // B. Osservatore Globale (Quick View)
    const globalObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) {
                        const foundSelects = node.querySelectorAll ? node.querySelectorAll('select.product-variant-container') : [];
                        foundSelects.forEach(select => observeSingleSelect(select));
                    }
                });
            }
        });
    });

    globalObserver.observe(document.body, { childList: true, subtree: true });

    // C. Listener generico
    document.addEventListener('change', (e) => {
        if(e.target.matches('select.product-variant-container')) {
           setTimeout(() => { manageVariantUI(e.target); }, 100); 
        }
    });

});




    // FIX TASTIERA MOBILE: SCROLL AUTOMATICO
    document.addEventListener('focusin', function(e) {
        if(window.innerWidth < 768 && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
            setTimeout(() => {
                e.target.scrollIntoView({behavior: 'smooth', block: 'center'});
            }, 400);
        }
    });

